import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableLayout from "../../../components/TableLayout";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions } from "../../../utilities/const";
import u1 from "../../../Assets/images/authBg.png";
import { Link } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import {
  DELETE_SUBADMIN,
  SUBADMINS_LIST,
  UPDATE_SYSTEM_ACCESS_STATUS,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import TableActions from "../../../components/Common/TableActions";
import { removeUnderScoreAndCapitalizeFirstLetter } from "../../../utilities/utilities";

const SystemAccess = () => {
  const { t } = useTranslation();
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    setCommisionModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: SUBADMINS_LIST,
  });

  const column = [
    {
      head: t("systemAccess.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: t("systemAccess.columns.name"),
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 fw-sbold">{item.name}</p>
      ),
    },
    { head: t("systemAccess.columns.email"), accessor: "email" },
    {
      head: t("systemAccess.columns.createdAt"),
      accessor: "date_created_utc",
      component: (item, key, arr) => (
        <p className="m-0 fw-sbold">
          {moment(item?.date_created_utc).format("YYYY-MM-DD ,  HH:MM")}
        </p>
      ),
    },
    {
      head: t("systemAccess.columns.lastModified"),
      accessor: "updatedAt",
      component: (item, key, arr) => (
        <p className="m-0 fw-sbold">
          {moment(item?.updatedAt).format("YYYY-MM-DD ,  HH:MM")}
        </p>
      ),
    },
    {
      head: t("systemAccess.columns.role"),
      accessor: "role",
      component: (item, key, arr) => (
        <p>
          {item.role === "SUBADMIN"
            ? t("systemAccess.role.subAdmin")
            : removeUnderScoreAndCapitalizeFirstLetter(item)}
        </p>
      ),
    },
    
    {
      head: t("systemAccess.columns.status"),
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 rounded ${
            item?.status === "Active"
              ? "bg-success text-white"
              : "bg-danger text-white"
          }`}
        >
          {item?.status === "Active" ? t("systemAccess.status.active") : t("systemAccess.status.inactive")}
        </span>
      ),
    },

    {
      head: t("systemAccess.columns.action"),
      accessor: "Action",
      component: (item) => {
        return (
          <TableActions
            editUrl={`/system-access/edit/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);
  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() => DELETE_SUBADMIN({ _id: deleteModel.dumpId }))
        }
      />
      <section className="systemAcess py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("systemAccess.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Link
                        to={"/system-access/add"}
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        {t("systemAccess.buttons.addNew")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SystemAccess;
